// Auto-generated from input.spec.js
export default {
  "tagName": "ui-input",
  "content": [
    "placeholder",
    "icon",
    "label"
  ],
  "contentAttributes": [
    "placeholder",
    "icon",
    "label"
  ],
  "types": [
    "search"
  ],
  "variations": [
    "fluid",
    "size"
  ],
  "states": [
    "hover",
    "focus",
    "active",
    "disabled"
  ],
  "settings": [
    "name",
    "type",
    "debounced",
    "debounce-interval",
    "clearable",
    "value"
  ],
  "attributes": [
    "placeholder",
    "icon",
    "label",
    "search",
    "hover",
    "focus",
    "active",
    "disabled",
    "fluid",
    "size",
    "name",
    "type",
    "debounced",
    "debounce-interval",
    "clearable",
    "value"
  ],
  "optionAttributes": {
    "disabled": "disabled",
    "mini": "size",
    "tiny": "size",
    "small": "size",
    "medium": "size",
    "large": "size",
    "big": "size",
    "huge": "size",
    "massive": "size",
    "clickable-disabled": "disabled"
  },
  "propertyTypes": {
    "placeholder": "string",
    "icon": "string",
    "label": "string",
    "search": "boolean",
    "hover": "boolean",
    "focus": "boolean",
    "active": "boolean",
    "disabled": "string",
    "fluid": "boolean",
    "size": "string",
    "name": "string",
    "type": "string",
    "debounced": "boolean",
    "debounce-interval": "number",
    "clearable": "string",
    "value": "string"
  },
  "allowedValues": {
    "disabled": [
      "disabled",
      "clickable"
    ],
    "size": [
      "mini",
      "tiny",
      "small",
      "medium",
      "large",
      "big",
      "huge",
      "massive"
    ]
  },
  "attributeClasses": [
    "icon",
    "label",
    "disabled"
  ],
  "defaultValues": {
    "name": "",
    "type": "text",
    "debounced": false,
    "debounce-interval": 150,
    "clearable": "",
    "value": ""
  }
};
